import { types } from "./mutations";
import OpenFileFootprint from "@/models/openFileFootprint.model";
import { EDITORS } from "./initialState";
import { saveAs } from "file-saver";


export default {
  /**
   * Opens a file in active editor or primary editor
   * @param {Object} context
   * @param {Object} payload
   * @param {String} payload.id id of the file to be opened
   */
  openFile: async ({ state, commit, dispatch }, { id, editor }) => {
    editor = editor || state.activeEditor;
    // check if the file is already opened in the active editor
    if (!state.openFiles[editor].includes(id)) {
      commit(types.SET_OPEN_FILES, {
        ...state.openFiles,
        [editor]: [...state.openFiles[editor], id],
      });
    }
    // set as the active file in the editor
    // commit(types.SET_ACTIVE_FILES, {
    //   ...state.activeFiles,
    //   [state.activeEditor]: id,
    // });

    // calling dispatch because activeFileId needs to be saved in indexedDB
    await dispatch("setActiveFile", {
      editor: editor,
      id: id,
    });
  },

  /**
   * Close a file from an editor
   * @param {Object} context
   * @param {Object} payload
   * @param {String} payload.editor Id/name of the editor
   * @param {String} payload.id id of the file to be closed
   */
  closeFile: async ({ state, commit, dispatch }, { editor, id }) => {
    // check if the file is currently opened
    if (state.activeFiles[editor] === id) {
      //set the first file in the editor's open files as the active file
      await dispatch("setActiveFile", {
        editor,
        id: state.openFiles[editor].filter((_id) => _id !== id)[0] || null,
      });
    }

    // remove the file from the open editors
    commit(types.SET_OPEN_FILES, {
      ...state.openFiles,
      // check if there are any open files in the editor
      [editor]: state.openFiles[editor]
        ? state.openFiles[editor].filter((_id) => _id !== id)
        : [],
    });
    if (state.openFiles[editor].length === 0) {
      // if one of the editors files is empty, always move things to primary editor
      // and clear out secondarye editor by default
      dispatch("swapEditorFiles");
    }
  },

  swapEditorFiles: async ({ state, commit, dispatch }) => {
    // if the primary editor is empty, move files from the secondary editor to primary
    if (state.openFiles[EDITORS.primary].length === 0) {
      if (state.openFiles[EDITORS.secondary].length > 0) {
        const secondaryOpenFiles = state.openFiles[EDITORS.secondary];
        const secondayActiveFile = state.activeFiles[EDITORS.secondary];
        // swap the editor files
        commit(types.SET_OPEN_FILES, {
          [EDITORS.primary]: secondaryOpenFiles,
          [EDITORS.secondary]: [],
        });
        // swap active files
        commit(types.SET_ACTIVE_FILES, {
          [EDITORS.primary]: secondayActiveFile,
          [EDITORS.secondary]: null,
        });
        dispatch("setActiveEditor", { editors: EDITORS.primary });
        // save the active file footprint
        let newActiveFile = new OpenFileFootprint({
          editor: EDITORS.primary,
          id: secondayActiveFile,
        });
      }
    }
  },

  /**
   * Close a file from all the available editor
   * used when a file is being deleted
   * @param {Object} context
   * @param {Object} payload
   * @param {String} payload.id id of the file to be closed
   */
  closeFileFromAllEditor: async ({ state, dispatch }, { id }) => {
    // remove the file from the open files list of all editors
    const editors = Object.keys(state.openFiles);
    for (let i = 0; i < editors.length; i++) {
      if (state.openFiles[editors[i]].includes(id)) {
        await dispatch("closeFile", { editor: editors[i], id });
      }
    }
  },

  /**
   * Set a file as an active file in an editor
   * @param {Object} context
   * @param {Object} payload
   * @param {String} payload.editor name of the editor
   * @param {String} payload.id id of the file to set active
   */
  setActiveFile: async ({ state, commit, dispatch }, { editor, id }) => {
    commit(types.SET_ACTIVE_FILES, {
      ...state.activeFiles,
      [editor]: id,
    });

    dispatch("setActiveEditor", { editor });
  },

  /**
   * Sets the active Editor
   */
  setActiveEditor: async ({ commit }, { editor }) => {
    commit(types.SET_ACTIVE_EDITOR, editor);
  },

  /**
   * Downloads a file
   * @param {Object} context
   * @param {Object} payload
   * @param {String} payload.id File id
   */
  downloadFile: async ({ rootGetters }, { id }) => {
    const file = rootGetters["Files/getFile"](id);
    const fileBlob = new Blob([file.contents], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(fileBlob, file.name);
  },

  /**
   * Sets the id of the dragging directory drop id
   */
  setDraggingId: async ({ commit }, { id }) => {
    commit(types.SET_DRAGGING_ID, id);
  },

  /**
   * sets Id of the file being dragged
   */
  setDraggingFileId: async ({ commit }, { id }) => {
    commit(types.SET_DRAGGING_FILE_ID, id);
  },
};
